export const generateHistogram = (estimates: number[]) => {
    const min = Math.min(...estimates);
    const max = Math.max(...estimates);
    const buckets = 5;
    const bucketSize = (max - min) / buckets;

    const histogram = Array(buckets)
      .fill(0)
      .map((_, i) => ({
        range: `${Math.round(min + i * bucketSize)}-${Math.round(
          min + (i + 1) * bucketSize
        )}`,
        count: 0,
      }));

    estimates.forEach((est) => {
      const bucketIndex = Math.min(
        Math.floor((est - min) / bucketSize),
        buckets - 1
      );
      histogram[bucketIndex].count++;
    });

    return histogram;
  };